import axios, { AxiosResponse } from 'axios'
import config from '@/utils/config'
import { Integer } from '@/models/common/commons'
import { DetailedPriceBreakdown } from '@/models/common/breakdown'
import { SearchRoomConfiguration } from '@/domain/model/room'

interface GetAvailabilityStatusRequest {
  dateFrom: string
  dateTo: string
  paxAges: number[]
  propertyId: string | number
}


export interface AvailabilityStatusDetails {
  status: number // 0, 1, 2
  cheapestPrice: number

  arrivalData: {
    isClosedToArrival: boolean
    arrivalMinLengthOfStay?: Integer
  }

  departureData: {
    isClosedToDeparture: boolean
  }

  stayData: {
    stayMinLengthOfStay?: Integer
  }

  minLeadTime?: Integer
}

export interface GetAvailabilityStatusResponse {
  availabilityStatus: {
    [D: string]: AvailabilityStatusDetails
  }
}

export interface SearchPropertyAvailabilityReq {
  checkin: string
  checkout: string
  currency: string
  promoCode?: string
  roomConfigurations: { identifier: number, paxAges: number[] }[]
  ratePlanIDs?: string[]
  roomIDs?: string[]
  session?: string
  showPromoCodeRatePlansOnly: boolean
}

export interface SearchPropertyAvailabilityRes {
  alternateHotelSessions?: Record<string, unknown>
  roomConfigurations: SearchRoomConfiguration[]
}

export async function getAvailabilityStatus(
  request: GetAvailabilityStatusRequest
): Promise<AxiosResponse<GetAvailabilityStatusResponse>> {
  return axios.post(
    `${config.searchAndBookApi}v1/accommodation/search/${request.propertyId}/availabilitystatus`,
    request,
    {
      params: {
        showarrivaldata: true,
        showdeparturedata: true,
        showstaydata: true
      }
    }
  )
}

export async function searchPropertyAvailability(
  propertyId: number,
  req: SearchPropertyAvailabilityReq
): Promise<AxiosResponse<SearchPropertyAvailabilityRes>> {
  return axios.post(
    `/search/v2/properties/${propertyId}`,
    req,
    {
      baseURL: config.apiUrl,
      params: {
        showdailyprices: true,
        showrpprices: true,
        showpkgprices: true,
        showspoprices: true,
        showboardprices: true,
        showphysicalroomavailability: true
      }
    }
  )
}
